/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Givefeedbackbutton2Inputs */

const en_settings_givefeedbackbutton2 = /** @type {(inputs: Settings_Givefeedbackbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give us your feedback`)
};

/**
* | output |
* | --- |
* | "Give us your feedback" |
*
* @param {Settings_Givefeedbackbutton2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_givefeedbackbutton2 = /** @type {((inputs?: Settings_Givefeedbackbutton2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Givefeedbackbutton2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_givefeedbackbutton2(inputs)
});
export { settings_givefeedbackbutton2 as "settings_giveFeedbackButton" }